import { stripHtml } from 'string-strip-html';

export const getStrippedHtml = (content: string) => {
  const html = stripHtml(content);

  return html.result || '';
};
